import Seo from "../components/Seo";
import { KineticLines, SectionLabel } from "../components/Reveal";

const SECTIONS = [
  {
    h: "1. Acceptance of Terms",
    p: ["By accessing or using the Bottom Line Improvements website (the “Site”), a division of Community Promotions, you agree to these Terms of Use. If you do not agree, please do not use the Site."],
  },
  {
    h: "2. Nature of Our Services",
    p: [
      "Bottom Line Improvements is a business savings and profitability resource. We help business owners explore opportunities relating to business expenses, technology, employee healthcare and benefits, and potential tax credits or incentives, and we connect interested owners with independent specialist providers.",
      "Bottom Line Improvements is not an insurance provider, accounting practice, tax advisory firm, or provider of the specialized services described on this Site. Evaluations, recommendations, and any professional work are performed solely by independent specialists.",
    ],
  },
  {
    h: "3. No Professional Advice; No Guarantees",
    p: [
      "Content on this Site is for general informational purposes and does not constitute tax, legal, insurance, or financial advice. No particular savings, credit, refund, or financial outcome is promised or guaranteed. Eligibility for any program or credit depends on your specific circumstances and is determined through evaluation by the relevant independent specialist.",
    ],
  },
  {
    h: "4. Referral Relationships",
    p: [
      "Bottom Line Improvements may receive referral compensation when customers choose services through participating provider relationships. Specialists are independent; we do not direct or control their professional judgment.",
    ],
  },
  {
    h: "5. Inquiries and Communications",
    p: [
      "Submitting an inquiry through the Site does not create a client, agency, or partnership relationship. You agree that the information you submit is accurate to the best of your knowledge and that we may contact you about your inquiry. You may opt out of optional communications at any time.",
    ],
  },
  {
    h: "6. Acceptable Use",
    p: [
      "You agree not to misuse the Site, including attempting to disrupt its operation, submitting fraudulent or automated inquiries, or using content from the Site without permission.",
    ],
  },
  {
    h: "7. Intellectual Property",
    p: ["All content, graphics, and design elements of the Site are the property of Bottom Line Improvements / Community Promotions unless otherwise noted, and may not be reproduced without permission."],
  },
  {
    h: "8. Limitation of Liability",
    p: ["To the fullest extent permitted by law, Bottom Line Improvements and Community Promotions are not liable for indirect, incidental, or consequential damages arising from your use of the Site or your interactions with independent specialists."],
  },
  {
    h: "9. Changes",
    p: ["We may update these Terms from time to time. Continued use of the Site after changes constitutes acceptance of the updated Terms."],
  },
  {
    h: "10. Contact",
    p: ["Questions about these Terms? Email admin@communitypromotionsllc.com or use the contact options on our Contact page."],
  },
];

export default function Terms() {
  return (
    <main data-testid="page-terms">
      <Seo
        title="Terms of Use"
        description="Terms governing use of the Bottom Line Improvements website, including the nature of our referral-based services and professional disclaimers."
        path="/terms"
      />
      <section className="relative overflow-hidden bg-ice pt-28 lg:pt-36 pb-12">
        <div className="absolute inset-0 bg-arch" aria-hidden="true" />
        <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <SectionLabel>Legal</SectionLabel>
          <KineticLines as="h1" className="mt-4 font-display font-extrabold tracking-tightest text-navy text-4xl sm:text-5xl" lines={["Terms of Use"]} />
          <p className="mt-4 text-sm text-slate">Effective date: [to be set at launch] · A division of Community Promotions</p>
        </div>
      </section>
      <section className="py-14 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 space-y-10">
          {SECTIONS.map((s) => (
            <div key={s.h}>
              <h2 className="font-display font-extrabold tracking-tight text-navy text-xl md:text-2xl">{s.h}</h2>
              {s.p.map((para, i) => (
                <p key={i} className="mt-3 text-[15px] leading-relaxed text-slate">{para}</p>
              ))}
            </div>
          ))}
        </div>
      </section>
    </main>
  );
}
